import Typography from "ds/components/Typography";
import Box from "ds/components/Box";
import TextEllipsis from "ds/components/TextEllipsis";
import ListEntitiesItemDescription from "components/ListEntitiesItem/Description";
import ListEntitiesItem from "components/ListEntitiesItem";
import { useDrawerVisibilityForId } from "ds/components/DrawerNew/useDrawerVisibilityForId";
import Timestamp from "components/Timestamp";

import GpgKeyListItemDropdown from "../GpgKeyListItemDropdown";
import { GpgKeyListItemProps } from "./types";
import { COLUMN_ORDER } from "../constants";
import styles from "./styles.module.css";

function GpgKeyListItem({ item }: GpgKeyListItemProps) {
  const isActive = useDrawerVisibilityForId(item.id);

  return (
    <ListEntitiesItem
      grid
      gridTemplate={COLUMN_ORDER}
      gap="0 large"
      key={item.id}
      isActive={isActive}
      role="row"
      className={styles.listItem}
    >
      <Box role="rowheader" direction="column" justify="center" gap="medium">
        <TextEllipsis tooltip={item.name} tooltipWidthMode="maxWidthSm">
          {(props) => (
            <Typography {...props} variant="p-body2" tag="p">
              {item.name}
            </Typography>
          )}
        </TextEllipsis>

        {item.description && (
          <ListEntitiesItemDescription id={item.id} description={item.description} noPadding />
        )}
      </Box>

      <Box role="cell" align="center">
        <TextEllipsis tooltip={item.id} tooltipWidthMode="maxWidthSm">
          {(props) => (
            <Typography {...props} tag="p" variant="p-body2">
              {item.id}
            </Typography>
          )}
        </TextEllipsis>
      </Box>

      <Box role="cell" align="center">
        <TextEllipsis tooltip={item.revokedBy || item.createdBy} tooltipWidthMode="maxWidthSm">
          {(props) => (
            <Typography {...props} tag="p" variant="p-body2">
              {item.revokedBy || item.createdBy}
            </Typography>
          )}
        </TextEllipsis>
      </Box>

      <Box role="cell" align="center">
        <Timestamp variant="p-body2" timestamp={item.revokedAt || item.createdAt} />
      </Box>

      <Box role="cell" align="center">
        <GpgKeyListItemDropdown item={item} />
      </Box>
    </ListEntitiesItem>
  );
}

export default GpgKeyListItem;
